import { useQuery } from '@tanstack/react-query'
import { photosService } from '@/api/services/photos.service'
import { queryKeys } from '@/api/query-keys'

export function useCandidDetail(candidId: string | null) {
  return useQuery({
    queryKey: queryKeys.photos.candidDetail(candidId),
    queryFn: () => photosService.getCandidDetail(candidId!),
    enabled: !!candidId,
    staleTime: 0,
    retry: false,
    refetchOnWindowFocus: false,
  })
}
